import { cacheRequest } from '@/base/MaRequestPooler.js'

export function fetchAppLocalization(trackId, axiosCfg) {
  return cacheRequest(`/app/${trackId}/ranked-localization`, axiosCfg)
}
